module.exports = function() {
  return new Worker(__webpack_public_path__ + "f7c34c2d07eeebbb766f.worker.js");
};